import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Address as AddressHelper } from 'src/app/entities/Address';
import { AddressElement, AddressInfo, Indirizzo, TableDocTypes } from 'src/app/entities/various';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { LoginService, UserData } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-soggetti-destinatario',
  templateUrl: './soggetti-destinatario.component.html',
  styleUrls: ['./soggetti-destinatario.component.css']
})
export class SoggettiDestinatarioComponent implements OnInit {

  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1,
        name: "Ricerca"
      },
      {
        id: 2,
        name: "Inserisci"
      }
    ]
  }

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  
  @Output() modelChange = new EventEmitter<AddressElement>();

  public addressHelper = new AddressHelper();

  titleSearch: string = "";
  searchFilter : string = "denominazione";

  loading : boolean = false;
  first: boolean = true;
  listAddress : Indirizzo[] = [];

  previousPage : number = 1;
  nextPage : number = 1;
  currentPage : number = 1;
  elencoPA : any;
  params : HttpParams;

  rubricaElement: Indirizzo = {
    id: 0,
    user_id: 0,
    denominazione: '',
    id_paese: '',
    partita_iva: '',
    codice_fiscale: '',
    indirizzo: '',
    civico: '',
    comune: '',
    provincia: '',
    nazione: '',
    cap: '',
    codice_destinatario: '',
    email: '',
    persona_fisica: 'f',
    nome: '',
    cognome: '',
    is_pa: 'f',
    pec: ''
  };
  

  constructor(public activeModal: NgbActiveModal, private userService: UserService, private confService : ConfigurationService, public loginService: LoginService) { 
    this.params = new HttpParams();
  }

  ngOnInit(): void {
  }

  close(){
    this.activeModal.close(null);
  }

  search(event: any){
    //if(this.titleSearch.length < 3 ) return;
    if(!event || event.keyCode == 13){
      this.retriveList();
    }
  }

  private async retriveList(){
    this.loading = true;
    this.listAddress = [];
    let userInfo = await this.loginService.getUserInfo();
    let currentUser = await this.loginService.getSessionUserInfo();
    //let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    this.params = this.params.append('endRow', 0);
    this.params = this.params.append('lastKeyVal', '');
    this.params = this.params.append('page', this.currentPage);
    this.params = this.params.append('pageDirection', 'FORWARD');
    this.params = this.params.append('pageSize', 10);
    this.params = this.params.append('pagination', true);
    this.params = this.params.append('paginationMode', 'SKIP');
    this.params = this.params.append('searchFilter', '{\"' + this.searchFilter + '\":\"' + this.titleSearch + '\"}');
    
    this.params = this.params.append('sortDir', 'ASC');
    this.params = this.params.append('sortKey', this.searchFilter);
    this.params = this.params.append('startRow', 1);
    this.params = this.params.append('totalPages', 0);
    this.params = this.params.append('totalRows', 0);
    
    let response = await this.userService.searchAddress(currentUser!.user_id, this.params);
    if(response.success){
      {
        this.listAddress = response.data.data;
      }
      /*let table : TableDocTypes = response.data as TableDocTypes;
      if((table.totalPages!= this.currentPage ) && (table.totalPages > this.nextPage ))
                this.nextPage=table.totalPages;
      
      this.listAddress = table.data;*/
    }
    this.first = false;
    this.loading = false;
  }

  prev(){
    this.currentPage=this.currentPage-1;
    this.retriveList();
  }

  next(){
    this.currentPage=this.currentPage+1;
    this.retriveList();
  }

  public selectOne(doc: Indirizzo){
    if(doc.selected){
      this.listAddress.filter(d => d.id != doc.id).forEach(d => d.selected = false);
    }
  }

  public save(){
    if(this.listAddress.filter(d => d.selected).length > 0){
      this.activeModal.close(this.listAddress.filter(d => d.selected)[0]);
    } else if (this.rubricaElement.denominazione != '' || (this.rubricaElement.nome != '' && this.rubricaElement.cognome != '')) {
      let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
      this.confService.salvaIndirizzo(userInfo!.user_id, this.rubricaElement).then(
        (res) => {
          if (res.success) {
            // inserito nel database, mostrare il destinatario a schermo
            this.activeModal.close(this.rubricaElement);
          }
        }
      )
      
    } else {
      this.activeModal.close(null);
    }
  }

  public toUpperCaseAndSubstitute(denominazione: string) {
    const chars: any = {
      'à': 'a',
      'è': 'e',
      'é': 'e',
      'ì': 'i',
      'ò': 'o',
      'ù': 'u'
    }
    return (denominazione).replace(/[àèéìòù]/g, m => chars[m]).toLocaleUpperCase();
  }

  public notifyChange(){
    this.modelChange.emit(this.rubricaElement);
  }

  public checkVatFormat(value :string,event :Event){
    let elm=(event.target as HTMLInputElement);
    if(elm.dataset.country!= undefined){
      if(elm.dataset.country =="IT"){
      return value.replace(/[^0-9]/g,"");    
      }
    }
    return value.toLocaleUpperCase();
  }

  setPersonaFisica() {
    if(this.rubricaElement!.persona_fisica == 't') {
      this.rubricaElement!.persona_fisica = 'f';
    } else {
      this.rubricaElement!.persona_fisica = 't';
    }
     
  }

  async cercaPA() {
    this.params= this.params.append('searchFilter', '{\"DESCR\":\"' + this.rubricaElement?.denominazione +'\"}');

    await this.confService.cercaPA(this.params).then(
      (res) => {
        this.elencoPA = res.data;
      }
    );

  }

  async selezionaRisultato(risultato: any) {
    
    this.params = this.params.append('searchFilter', '{\"COD_AMM\":\"' + risultato.cod_amm +'\"}');

    await this.confService.cercaPA(this.params).then(
      (res) => {
        this.elencoPA = null;
        this.rubricaElement!.denominazione = res.data.des_amm;
        this.rubricaElement!.email = res.data.mail1;
        this.rubricaElement!.codice_fiscale = res.data.cf;
        this.rubricaElement!.indirizzo = res.data.indirizzo;
        this.rubricaElement!.nazione = 'IT';
        this.rubricaElement!.comune = res.data.comune;
        this.rubricaElement!.provincia = res.data.provincia;
        this.rubricaElement!.cap = res.data.cap;
        this.rubricaElement!.is_pa = 't';
      }
    );
    
  }
  
}
